import { useMemo } from 'react';

import { useServiceFeatures } from 'hooks/useServiceContext';
import { Undef } from 'types/UtilityTypes';

import type { HeightConfig } from '../../utils/ltlMetrics';

// Same threshold/override object passed to LTL metrics and trailer axis labels
// when the cubic-feet custom calculation feature is enabled.
export function useCubicFeetHeightConfig(): Undef<HeightConfig> {
  const { serviceFeaturesEnabled, quickQuoteConfig } = useServiceFeatures();
  const isCubicFeetCustomCalculationEnabled =
    serviceFeaturesEnabled.isCubicFeetCustomCalculationEnabled;

  return useMemo(() => {
    if (
      isCubicFeetCustomCalculationEnabled &&
      quickQuoteConfig?.cubicFeetCalculationConfig &&
      quickQuoteConfig.cubicFeetCalculationConfig.heightThresholdInches > 0 &&
      quickQuoteConfig.cubicFeetCalculationConfig.overrideHeightInches > 0
    ) {
      const config = {
        heightThresholdInches:
          quickQuoteConfig.cubicFeetCalculationConfig.heightThresholdInches,
        overrideHeightInches:
          quickQuoteConfig.cubicFeetCalculationConfig.overrideHeightInches,
      };

      return config;
    }

    return undefined;
  }, [
    isCubicFeetCustomCalculationEnabled,
    quickQuoteConfig?.cubicFeetCalculationConfig?.heightThresholdInches,
    quickQuoteConfig?.cubicFeetCalculationConfig?.overrideHeightInches,
  ]);
}
